import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, isRef as _isRef } from "vue"

const _hoisted_1 = { class: "drawer-header" }
const _hoisted_2 = { class: "title-main" }
const _hoisted_3 = { class: "title-warning" }
const _hoisted_4 = { class: "part-header" }
const _hoisted_5 = { class: "part-action" }
const _hoisted_6 = { class: "title-warning" }

import {
  ref,
  PropType,
  computed,
  watch,
  nextTick,
} from 'vue'
import useI18nTl from '@/hooks/useI18nTl'
import SelectOperator from '@/components/SelectOperator.vue'
import PriceingTariffElecV2 from './PriceingTariffElecV2.vue'
import { upsertPriceingClock } from '@/api/operation'
import { ElMessage } from 'element-plus'
import { UseVehicleType, PriceingInfo, KWHTariffTag, ClockingPriceingVer } from '@/types/types'
import FormRulesFactory from '@/common/formRules'
import PriceingPower from './PriceingPower.vue'

import InfoTooltip from '@/components/InfoTooltip.vue'

// const {} = useProtocolEnums()
enum BillingMethodTypes {
  POWER, //按功率计费
  ELECTARIFF, //按电量计费
}
// form rules

import { defineComponent } from 'vue'
import { cloneDeep, isArray } from 'lodash'

const __default__ = defineComponent({
  name: 'ClockPriceingDrawer',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  modelValue: {
    type: Boolean,
    required: true,
  },
  isEdit: {
    type: Boolean,
  },
  priceingInfo: {
    type: Object as PropType<Partial<PriceingInfo>>,
  },
  priceingClockInfo: {
    type: Object as PropType<Partial<ClockingPriceingVer>>,
  },
  stationId: [String, Number],
  operatorId: Number,
},
  emits: ['update:modelValue', 'submit', 'submitted'],
  setup(__props, { expose, emit }) {

const props = __props


const { t, tl } = useI18nTl('Operation')
const priceFormRule = ref({
  ...FormRulesFactory.generateCustomRules(
    ['operatorId', 'priceing.publishTime'],
    'selectNone',
    'selectNone',
  ),
  ...FormRulesFactory.generateCustomRules(['priceing.name'], 'inputEmpty', 'inputInvalid'),
})

const priceingTariffElec = ref()
const priceingPower = ref()
const supportDeepValley = ref<boolean>(false)
const billingMethod = ref<BillingMethodTypes>()
let subsForm = ref()
const record = ref<Record<string, any>>({
  priceing: {
    elecTariffs: [],
    chargingTimeTariffs: [],
    occupyTariff: { freeTime: 0, maxFee: 0, price: 0 },
  },
})
const clearValidate = () => {
  nextTick(() => {
    let t = setTimeout(() => {
      clearTimeout(t)
      subsForm.value?.clearValidate()
    }, 300)
  })
}
const showDialog = computed({
  get: () => props.modelValue,
  set: (val: boolean) => {
    emit('update:modelValue', val)
    if (!val) {
      clearValidate()
      record.value = {
        priceing: {
          elecTariffs: [],
          chargingTimeTariffs: [],
          occupyTariff: { freeTime: 0, maxFee: 0, price: 0 },
        },
      }
    }
  },
})
// 验证组件表单
const validateComponentsForm = async () => {
  try {
    let result
    switch (billingMethod.value) {
      case BillingMethodTypes.POWER: {
        result = await priceingPower.value.validate()
        break
      }
      case BillingMethodTypes.ELECTARIFF: {
        result = await priceingTariffElec.value.validate()
      }
    }
    return result
  } catch (err) {
    return false
  }
}
const submit = async () => {
  // if (priceingTariffElec.value) priceingTariffElec.value.validate()
  // await subsForm.value?.validate()

  console.log('-----> priceing submit')

  let isValid = await validateComponentsForm()
  clearRedundantData()
  // 验证 subsForm
  const subsFormValid = await subsForm.value?.validate()

  if (!subsFormValid || !isValid) {
    console.log('-----> priceing submit subsFormValid')
    return
  }
  record.value.vt = UseVehicleType.UVT_CART

  upsertPriceingClock({
    priceingVer: record.value.priceing,
  }).then((res: any) => {
    if (props.isEdit) {
      ElMessage.success(t(`Base.editSuccess`))
    } else {
      ElMessage.success(t(`Base.createSuccess`))
    }
    showDialog.value = false
    emit('submitted')
  })
}

const disabledDate = (date: Date) => {
  const today = new Date()
  today.setHours(0, 0, 0, 0)
  date.setHours(0, 0, 0, 0)
  return date < today
}

// Disable all minutes except 0 (to make it hour-only selection)
const disabledMinutes = () => {
  return Array.from({ length: 59 }, (_, i) => i + 1)
}

// Disable all seconds except 0
const disabledSeconds = () => {
  return Array.from({ length: 59 }, (_, i) => i + 1)
}
// 清除未选择数据
const clearRedundantData = () => {
  switch (billingMethod.value) {
    case BillingMethodTypes.POWER:
      record.value.priceing.elecTariffs = []
      break
    case BillingMethodTypes.ELECTARIFF:
      record.value.priceing.feeList = ''
      record.value.priceing.unitPrice = 0
      record.value.priceing.chargingTimeTariffs = []
      break
  }
}

watch(
  () => props.modelValue,
  (val) => {
    if (props.isEdit) {
      record.value.priceing = {
        ...cloneDeep(props.priceingInfo?.priceing || {}),
        ...cloneDeep(props.priceingClockInfo || {}),
        priceingId: props.priceingInfo?.priceing?.id,
        operatorId: props.priceingInfo?.operator?.id || '0',
      }
      if (!record.value.priceing.occupyTariff) {
        record.value.priceing.occupyTariff = { freeTime: 0, maxFee: 0, price: 0 }
      }
      billingMethod.value =
        record.value.priceing.elecTariffs.length > 0
          ? BillingMethodTypes.ELECTARIFF
          : BillingMethodTypes.POWER
      supportDeepValley.value =
        isArray(record.value.priceing.elecTariffs) &&
        record.value.priceing.elecTariffs.some(
          (item) => item.tag === KWHTariffTag.KWHTT_DEEP_VALLEY,
        )
    } else {
      record.value = {
        priceing: {
          ...props.priceingInfo?.priceing,
          publishTime: '',
          id: props.priceingClockInfo?.id || '0',
          priceingId: props.priceingInfo?.priceing?.id,
          operatorId: props.priceingInfo?.operator?.id || '0',
        },
      }
      billingMethod.value = BillingMethodTypes.ELECTARIFF
    }
  },
  { immediate: true },
)
expose({
  clearValidate,
})

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createBlock(_component_el_drawer, {
    modelValue: _unref(showDialog),
    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_isRef(showDialog) ? (showDialog).value = $event : null)),
    "lock-scroll": false,
    "close-on-click-modal": true,
    size: "60%",
    "z-index": 1999,
    "custom-class": "evse-drawer",
    "destroy-on-close": true
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(props.isEdit ? _unref(tl)('editClockPrice') : _unref(tl)('addClockPrice')), 1),
        _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(tl)('priceTip')), 1)
      ])
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_el_button, {
        onClick: _cache[12] || (_cache[12] = ($event: any) => (showDialog.value = false))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('Base.cancel')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_button, {
        disabled: !_ctx.$hasPermission('post'),
        onClick: submit
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(props.isEdit ? _ctx.$t('Base.saveChanges') : _ctx.$t('Base.add')), 1)
        ]),
        _: 1
      }, 8, ["disabled"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        "label-position": "top",
        "require-asterisk-position": "right",
        model: record.value,
        "validate-on-rule-change": false,
        ref_key: "subsForm",
        ref: subsForm,
        rules: priceFormRule.value
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_row, { gutter: 20 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(tl)('priceingName'),
                    prop: "priceing.name"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: record.value.priceing.name,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((record.value.priceing.name) = $event)),
                        disabled: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(t)('Operation.operator'),
                    prop: "priceing.operatorId",
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(SelectOperator, {
                        modelValue: record.value.priceing.operatorId,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((record.value.priceing.operatorId) = $event)),
                        disabled: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              (billingMethod.value == BillingMethodTypes.POWER)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createVNode(_component_el_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, { prop: "unitPrice" }, {
                          label: _withCtx(() => [
                            _createElementVNode("label", null, _toDisplayString(_unref(t)('Operation.priceingTariffUnitPrice')), 1),
                            _createVNode(InfoTooltip, {
                              content: _ctx.$t('Operation.priceingTariffUnitPriceDesc'),
                              place: _ctx.left
                            }, null, 8, ["content", "place"])
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: record.value.priceing.unitPrice,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((record.value.priceing.unitPrice) = $event)),
                              disabled: ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, { prop: "freeTime" }, {
                          label: _withCtx(() => [
                            _createElementVNode("label", null, _toDisplayString(_unref(t)('Operation.priceingTariffFreeTime')), 1),
                            _createVNode(InfoTooltip, {
                              content: _ctx.$t('Operation.priceingTariffFreeTimeDesc'),
                              place: _ctx.left
                            }, null, 8, ["content", "place"])
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: record.value.priceing.freeTime,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((record.value.priceing.freeTime) = $event)),
                              disabled: ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ], 64))
                : _createCommentVNode("", true),
              (billingMethod.value == BillingMethodTypes.ELECTARIFF)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createVNode(_component_el_col, { span: 8 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, { prop: "priceing.occupyTariff.freeTime" }, {
                          label: _withCtx(() => [
                            _createElementVNode("label", null, _toDisplayString(_unref(t)('Operation.freeOccupyTime')), 1),
                            _createVNode(InfoTooltip, {
                              content: _ctx.$t('Operation.occupyTips')
                            }, null, 8, ["content"])
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: record.value.priceing.occupyTariff.freeTime,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((record.value.priceing.occupyTariff.freeTime) = $event)),
                              disabled: ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 8 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          prop: "priceing.occupyTariff.maxFee",
                          label: _unref(t)('Operation.maxOccupyFee')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: record.value.priceing.occupyTariff.maxFee,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((record.value.priceing.occupyTariff.maxFee) = $event)),
                              disabled: ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 8 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          prop: "priceing.occupyTariff.price",
                          label: _unref(t)('Operation.occupyPrice')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: record.value.priceing.occupyTariff.price,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((record.value.priceing.occupyTariff.price) = $event)),
                              disabled: ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 8 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          prop: "priceing.occupyTariff.price",
                          label: _unref(t)('Operation.occupyPrice')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: record.value.priceing.occupyTariff.price,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((record.value.priceing.occupyTariff.price) = $event)),
                              disabled: ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ]),
                      _: 1
                    })
                  ], 64))
                : _createCommentVNode("", true),
              _createVNode(_component_el_col, { span: 8 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    prop: "priceing.publishTime",
                    label: _unref(t)('Operation.publishTime'),
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_date_picker, {
                        modelValue: record.value.priceing.publishTime,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((record.value.priceing.publishTime) = $event)),
                        "disabled-date": disabledDate,
                        type: "datetime",
                        format: "YYYY-MM-DD HH:mm:ss",
                        "value-format": "YYYY-MM-DD HH:mm:ss",
                        "disabled-minutes": disabledMinutes,
                        "disabled-seconds": disabledSeconds
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_row, { gutter: 20 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_divider)
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(_component_el_radio_group, {
                        modelValue: billingMethod.value,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((billingMethod).value = $event))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_radio, {
                            label: BillingMethodTypes.ELECTARIFF
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(tl)('priceingTariffElec')), 1)
                            ]),
                            _: 1
                          }, 8, ["label"]),
                          _createVNode(_component_el_radio, {
                            label: BillingMethodTypes.POWER
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(tl)('priceingPower')), 1)
                            ]),
                            _: 1
                          }, 8, ["label"]),
                          _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(tl)('selectPricingOnBicycleTips')), 1)
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createElementVNode("div", null, [
                        _createTextVNode(_toDisplayString(_ctx.$t('Operation.supportDeepValley')) + " ", 1),
                        _createVNode(_component_el_switch, {
                          modelValue: supportDeepValley.value,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((supportDeepValley).value = $event))
                        }, null, 8, ["modelValue"])
                      ])
                    ])
                  ]),
                  (billingMethod.value === BillingMethodTypes.POWER)
                    ? (_openBlock(), _createBlock(PriceingPower, {
                        key: 0,
                        ref_key: "priceingPower",
                        ref: priceingPower,
                        list: record.value.priceing?.chargingTimeTariffs
                      }, null, 8, ["list"]))
                    : _createCommentVNode("", true),
                  (billingMethod.value === BillingMethodTypes.ELECTARIFF)
                    ? (_openBlock(), _createBlock(PriceingTariffElecV2, {
                        key: 1,
                        modelValue: record.value.priceing.elecTariffs,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((record.value.priceing.elecTariffs) = $event)),
                        ref_key: "priceingTariffElec",
                        ref: priceingTariffElec,
                        supportDeepValley: supportDeepValley.value
                      }, null, 8, ["modelValue", "supportDeepValley"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})